import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

export const GradientLayout = () => {
  return (
    <Layout
      style={{
        height: '100vh',
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(#5b8e57 0%, #90b18b 34%, #fffdf8 100%)',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
};
